// extracted by mini-css-extract-plugin
export default {"formControl":"TfOenvqx_b2CwpABRYGK","iconBox":"ZiZPzusBawh4b2TMckTJ","input":"BBhf_YmadGb9JNg6EMLZ","error":"ansU7bHNrBuXWgxueqc0"};